import { Component, input, ChangeDetectionStrategy } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { S25States } from "../../services/state/state.map";
import { S25RouterLinkDirective } from "./s25.router.link.directive";

@TypeManagerDecorator("s25-ng-router-link")
@Component({
    selector: "s25-ng-router-link",
    template: `<a s25-ng-router-link [stateName]="stateName()" [stateParams]="stateParams()">{{ text() }}</a>`,
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [S25RouterLinkDirective],
})
export class S25RouterLinkComponent {
    readonly text = input.required<string>();
    readonly stateName = input.required<S25States.Name>();
    readonly stateParams = input<Record<string, string | number>>();
}
